import { InjectionToken } from '@angular/core';

export type ErrorMessages = Record<
  string,
  Record<string, string | ((error: any) => string)>
>;

export const ERROR_MESSAGES_TOKEN = new InjectionToken<ErrorMessages>(
  'ERROR_MESSAGES'
);
